export interface UserAgreementDocument {
    id: string;
    name: string;
    title: string;
    text: string;
    language: string;
    lastUpdateTimestamp: number;
    acceptanceRequested: boolean;
    type: UserAgreementDocumentType;
    targets: UserAgreementDocumentTarget[];
    consentPresence: UserAgreementDocumentConsentPresence;
    digitalServiceIds: string[]
}

export enum UserAgreementDocumentType {
    PRIVACY_POLICY = 'PRIVACY_POLICY',
    TERMS_OF_SERVICE = 'TERMS_OF_SERVICE',
    ADDENDUM = 'ADDENDUM'
}

export enum UserAgreementDocumentTarget {
    CUSTOMER = 'CUSTOMER',
    CHANNEL_PARTNER = 'CHANNEL_PARTNER',
    DATA_RECIPIENT = 'DATA_RECIPIENT',
    ORGANIZATION = 'ORGANIZATION'
}

export enum UserAgreementDocumentConsentPresence {
    REGISTRATION_FORM = 'REGISTRATION_FORM',
    DIGITAL_SERVICE_SUBSCRIPTION = 'DIGITAL_SERVICE_SUBSCRIPTION',
    NONE = 'NONE'
}